import TEAM from './team';
import COLORS from './colors';

export { COLORS, TEAM };
